<template>
    <div>
        <section-header
            ref="selectHeader"
            title="Select Dependent Variable (Required)"
        ></section-header>
        <analysis-variable-selection
            ref="analysisVariableSelection"
            variableType="dependent"
            :title="''"
            v-model="selectionModel.v.dependent"
            :isEnabled="true"
            v-on:variableIsSelected="selectedVariableChanged"
            :theVariable="selectionModel.v.dependent"
            :isRequired="true"
        ></analysis-variable-selection>
        <app-navigator
            ref="appNavigator"
            :router="$router"
            nextButtonTitle="Select a variable to continue"
        ></app-navigator>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import commonModelHelper from '@/scripts/commonModelHelper';
import store from '@/store';
import sectionHeader from '@/components/sub/sectionHeader';
import appNavigator from '@/components/layout/appNavigator';
import analysisVariableSelection from '@/components/analysisVariableSelection';

function selectedVariableChanged(variable) {
    const vm = this;
    vm.selectionModel.v.dependent = variable;
    store.dispatch('selModel/setReadyForNextStep');
}
export default {
    components: {
        sectionHeader,
        appNavigator,
        analysisVariableSelection
    },
    data: function () {
        var vm = this;
        current.initializeLogisticRegressionValues(vm);
        var omittedVariables = { year: true, location: true };
        commonModelHelper.initializeStep(vm, 'selectDependentVariable');
        return {
            modelHelper: current.modelHelper,
            selectionModel: current.selectionModel,
            omittedVariables: omittedVariables,
            store: store
        };
    },
    mounted() {
        let vm = this;
        if (vm.$refs.analysisVariableSelection)
            vm.$refs.analysisVariableSelection.updateSelection({
                omittedVariables: vm.omittedVariables
            });
    },
    methods: { selectedVariableChanged }
};
</script>

<style scoped>
.spaced-out {
    margin-top: 20px;
    margin-bottom: 20px;
}

.dropdown-menu label.radio input[type='radio'] {
    visibility: hidden;
}

.dropdown-menu label.radio {
    padding-left: 10px;
}
</style>
